/**
 * Custom SVG icons that supplement the lucide-react set in the CMS icon bank
 * (apps/admin-panel/src/lib/iconBank.tsx + apps/website/lib/icon-bank.tsx).
 * Both apps merge CUSTOM_ICONS in, so there is exactly one place to register
 * a new custom icon instead of two.
 *
 * To add a new icon:
 * 1. Convert your <svg>...</svg> markup into a small component under ./icons
 *    (see icons/ElevatorIcon.tsx) — mainly renaming kebab-case SVG attributes
 *    to camelCase (stroke-width -> strokeWidth, fill-rule -> fillRule,
 *    clip-rule -> clipRule) and swapping any hardcoded color for
 *    "currentColor" so it inherits color like the rest of the icon bank.
 * 2. Add one entry below with a unique kebab-case `key` and a Persian/English
 *    search `label`.
 * 3. That's it — it shows up in the admin icon picker and resolves on the
 *    website automatically.
 */
import ElevatorIcon from './icons/ElevatorIcon';
import EvaporativeCoolerIcon from './icons/EvaporativeCoolerIcon';
import type { CustomIconEntry } from './types';

export const CUSTOM_ICONS: CustomIconEntry[] = [
  { key: 'elevator', label: 'آسانسور elevator lift', Icon: ElevatorIcon },
  { key: 'evaporative-cooler', label: 'کولر آبی evaporative cooler', Icon: EvaporativeCoolerIcon },
];

export type { CustomIconComponent, CustomIconEntry, CustomIconProps } from './types';
